import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';

export interface IProductAdditionDTO extends IBaseEntityDTO {
  name: string;
  description: string;
}

export class ProductAdditionDTO extends BaseEntityDTO implements IProductAdditionDTO {
  name: string;
  description: string;

  constructor(data?: Partial<ProductAdditionDTO>) {
    super();

    this.name = data?.name ?? '';
    this.description = data?.description ?? '';
  }
}
